export enum PDF_TYPES {
  local,
  external
}
